export default "__VITE_ASSET__2_SHqQNt__"